export default function () {
  const button = window.document.getElementById('c-skip-main');

  function firstInteractiveElement() {
    let el = null;
    const mcAll = window.document.querySelectorAll('main a, main input, main select, main button:not(.c-skip-main), '
      + 'main textarea, main [role="button"], main .wpcf7-list-item-label, footer a, footer input, footer select, '
      + 'footer button, footer textarea');

    mcAll.forEach((item) => {
      if (el !== null) {
        return false;
      }

      const tabindex = item.hasAttribute('tabindex') ? item.getAttribute('tabindex') : null;
      const isHidden = item.offsetParent === null;

      if (
        parseInt(tabindex, 10) === -1
        || item.getAttribute('type') === 'hidden'
        || isHidden
      ) {
        return false;
      }

      el = item;

      return null;
    });

    document.body.classList.add('c-keyDown');
    return el;
  }

  function scrollToContent() {
    const mc = firstInteractiveElement();

    if (mc) {
      mc.focus();
    }
  }

  if (button) {
    button.addEventListener('keypress', (event) => {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode === 13) {
        scrollToContent();
      }
    });
  }
}
